import { render, staticRenderFns } from "./BlockListAccordionCustom.vue?vue&type=template&id=474650c4&"
import script from "./BlockListAccordionCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListAccordionCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports